import React, { useState } from "react";
import { BIG_LOGO } from "../../constants/images";
import printJS from "print-js";
import { PDFReader } from "reactjs-pdf-reader";
import {
  IconCheveronLeft,
  IconCheveronRight,
  IconPlus,
  IconPrinter,
  IconSubtrac,
} from "../../icons/Icon";

const stepScale = 0.25;
const limitZoom = 2;

const SmuPdfPreview = ({ pdf, allowPrint = true }) => {
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [scale, setScale] = useState(1);

  const onDocumentComplete = (_totalPages) => {
    setTotalPages(_totalPages);
  };

  const page = (add) => {
    setCurrentPage((val) => {
      const newVal = val + add;
      return add > 0
        ? newVal < totalPages
          ? newVal
          : totalPages
        : newVal > 0
        ? newVal
        : 1;
    });
  };

  const zoom = (step) => {
    setScale((val) => {
      const newVal = val + step;
      return step > 0
        ? newVal < limitZoom
          ? newVal
          : limitZoom
        : newVal > 0
        ? newVal
        : 0.25;
    });
  };

  const print = () => {
    printJS(pdf);
  };

  return (
    <div className="cointainer-pdf">
      <div className="logo-in-pdf px-2">
        <img src={BIG_LOGO} alt="LOGO" />
      </div>

      <div className="background-pdf">
        <div
          id="pdf-print"
          className="wrapper-pdf"
          style={{ transform: `scale(${scale})` }}
        >
          {Boolean(pdf) && (
            <PDFReader
              url={pdf}
              scale={0.8}
              page={currentPage}
              onDocumentComplete={onDocumentComplete}
            />
          )}
        </div>
      </div>

      <div className="counter-bar mt-4 mb-5">
        <div className="counter">
          {currentPage} / {totalPages}
        </div>
      </div>

      <div className="button-bar mx-auto">
        <div className="control">
          <div className="control-group mx-4 me-auto">
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => zoom(stepScale)}
            >
              <IconPlus color="#fff" />
            </button>
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => zoom(-stepScale)}
            >
              <IconSubtrac color="#fff" />
            </button>
          </div>

          <div className="control-group mx-4 mx-auto">
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => setCurrentPage(1)}
            >
              <IconCheveronLeft color="#fff" />
              <IconCheveronLeft color="#fff" />
            </button>
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => page(-1)}
            >
              <IconCheveronLeft color="#fff" />
            </button>
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => page(1)}
            >
              <IconCheveronRight color="#fff" />
            </button>
            <button
              type="button"
              className="smu-generic-button btn-action"
              onClick={() => setCurrentPage(totalPages)}
            >
              <IconCheveronRight color="#fff" />
              <IconCheveronRight color="#fff" />
            </button>
          </div>

          <div className="control-group mx-4 ms-auto">
            {allowPrint && (
              <button
              type="button"
              className="smu-generic-button btn-action ms-auto"
              onClick={() => print()}
            >
              <IconPrinter color="#fff"/>
            </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmuPdfPreview;
